import React from 'react';
import { motion } from 'framer-motion';
import { Category } from '../types';

interface TabsProps {
  categories: Category[];
  activeCategory: number | null;
  setActiveCategory: (id: number | null) => void;
}

const Tabs: React.FC<TabsProps> = ({ categories, activeCategory, setActiveCategory }) => {
  return (
    <div className="flex overflow-x-auto pb-2 hide-scrollbar justify-center">
      <div className="flex flex-wrap justify-center gap-4 max-w-7xl">
        <button
          onClick={() => setActiveCategory(null)}
          className={`px-8 py-4 rounded-full whitespace-nowrap transition-all min-w-max text-lg ${
            activeCategory === null
              ? 'bg-gradient-to-r from-accent-blue to-navy-blue text-white shadow-lg shadow-accent-blue/20'
              : 'bg-deep-navy text-medium-gray hover:bg-navy-blue'
          }`}
        >
          All Projects
        </button>
        
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => setActiveCategory(category.id)}
            className={`px-8 py-4 rounded-full whitespace-nowrap transition-all min-w-max text-lg ${
              activeCategory === category.id
                ? 'bg-gradient-to-r from-accent-blue to-navy-blue text-white shadow-lg shadow-accent-blue/20'
                : 'bg-deep-navy text-medium-gray hover:bg-navy-blue'
            }`}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;